import { useTranslation } from 'react-i18next';
import {
  AspectRatio,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Text,
} from '@shared/ui';

export function AspectRatioShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.layout.aspectRatio.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.layout.aspectRatio.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <AspectRatio ratio={16 / 9} className="rounded-lg border border-border">
          <div className="flex h-full w-full items-center justify-center rounded-lg bg-gradient-to-br from-muted to-muted/40">
            <Text size="sm" color="muted">
              {t('uiLibrary.layout.aspectRatio.placeholder')}
            </Text>
          </div>
        </AspectRatio>
      </CardContent>
    </Card>
  );
}
